import React, { useEffect, useState } from "react";
import Marker from "./Marker";
import { GOOGLE_MAP_API_URL, GOOGLE_MAP_API_KEY } from "../../config";

export default function GoogleMap(props) {
  const [children, setChildren] = useState(null);

  useEffect(() => {
    function onScriptLoad() {
      if (!!props.options && !!props.options.center) {
        const map = new window.google.maps.Map(
          document.getElementById(props.id),
          props.options
        );

        //cloning the map object to Marker component
        setChildren(
          React.Children.map(props.children, child => {
            return child.type === Marker
              ? React.cloneElement(child, {
                  map
                })
              : child;
          })
        );
      }
    }

    if (!window.google) {
      //console.log("Loading Google Map API scripts");

      const s = document.createElement("script");
      s.type = "text/javascript";
      s.src = `${GOOGLE_MAP_API_URL}?key=${GOOGLE_MAP_API_KEY}`;
      const x = document.getElementsByTagName("script")[0];
      x.parentNode.insertBefore(s, x);
      // Below is important.
      //We cannot access google.maps until it's finished loading
      s.addEventListener("load", e => {
        onScriptLoad();
      });
    } else {
      onScriptLoad();
    }
  }, [props]);

  return (
    <div style={{ width: props.width, height: props.height }} id={props.id}>
      {children}
    </div>
  );
}
